import { defineMessages } from 'react-intl';

export const joinTeamFailMessages = defineMessages({
  fallbackTeamName: {
    defaultMessage: 'team',
    id: 'tZlNOsmQ0C',
    description:
      'Fallback label for the team name in join error titles when the name is unknown',
  },
  couldNotAddTitle: {
    defaultMessage: 'You couldn’t be added to team: {teamName}',
    id: '+r4Fs/Pw+F',
    description: 'Heading when the user could not be added to the named team',
  },
  alreadyJoinedDescription: {
    defaultMessage:
      'You have already joined a team, or <support>contact support</support>.',
    id: '04ELD/Soc6',
    description:
      'Explains the user is already on a team; includes a link to contact support',
  },
  alreadyJoinedDescriptionViaIt: {
    defaultMessage: 'You have already joined a team, or contact your IT team.',
    id: '6J9vjTrvII',
    description:
      'Explains the user is already on a team; points to their IT team where Heidi support is unavailable',
  },
  notFoundTitle: {
    defaultMessage: 'Team not found',
    id: 'yS1+xFL3b9',
    description: 'Heading when the invited team does not exist',
  },
  notFoundDescription: {
    defaultMessage:
      'This team no longer exists or you don’t have permission to access it.',
    id: '+nhdrINxoE',
    description: 'Body when the team cannot be found or accessed',
  },
  notAllowedToAddTitle: {
    defaultMessage: 'New members cannot be added to {teamName}',
    id: 'D8fBfKhrmU',
    description: 'Heading when the team is not accepting new members',
  },
  notAllowedToAddDescription: {
    defaultMessage: 'This team is not accepting new members at this time.',
    id: 'CN/7/W5rLs',
    description: 'Body when the team blocks new members',
  },
  userNotAllowedTitle: {
    defaultMessage: 'Access denied',
    id: 'NZJCuf8MCF',
    description: 'Heading when the user is not allowed to join',
  },
  userNotAllowedDescription: {
    defaultMessage: 'You don’t have permission to join this team',
    id: 'kr2P0FwQTx',
    description: 'Body when the user lacks permission to join',
  },
  invitationNotFoundTitle: {
    defaultMessage: 'Invalid invitation',
    id: 'zRuDBtL8jU',
    description: 'Heading when the invite link is invalid',
  },
  invitationNotFoundDescription: {
    defaultMessage: 'This invitation link is no longer valid.',
    id: 'AjrtNLyxWo',
    description: 'Body when the invite link is invalid',
  },
  invitationExpiredTitle: {
    defaultMessage: 'Invitation expired',
    id: 'dB5LljA9S9',
    description: 'Heading when the team invite has expired',
  },
  invitationExpiredDescription: {
    defaultMessage: 'This invitation has expired. Please request a new invitation.',
    id: 'SwkNWkJtUY',
    description: 'Body when the invite has expired',
  },
  regionMismatchDescription: {
    defaultMessage:
      'Your region does not match the team’s region, and we do not support multi-region teams at this time. If you think there has been a mistake please <contact>contact us</contact>.',
    id: 'ZVVjtl6up4',
    description: 'Body when user and team regions differ; includes a link to contact us',
  },
  regionMismatchDescriptionViaIt: {
    defaultMessage:
      'Your region does not match the team’s region, and we do not support multi-region teams at this time. If you think there has been a mistake please contact your IT team.',
    id: 'aoT7aQG4E5',
    description:
      'Body when user and team regions differ; points to their IT team where Heidi support is unavailable',
  },
  genericDescription: {
    defaultMessage: 'Please try again later or <support>contact support</support>.',
    id: 'yoKN4mqC/G',
    description: 'Generic failure body with a link to contact support',
  },
  genericDescriptionViaIt: {
    defaultMessage: 'Please try again later or contact your IT team.',
    id: '4oDEpyNlZC',
    description:
      'Generic failure body pointing to their IT team where Heidi support is unavailable',
  },
  returnButton: {
    defaultMessage: 'Return',
    id: 'm0fh+46LeN',
    description: 'Button to leave the join error modal and go back',
  },
});
